import { EventTriggers } from '../rulesets';
import { RulesetTemplate } from './template';

export const ConsentRTM: { [key: string]: RulesetTemplate } = {
  OptIn: {
    icon: 'modal-window',
    name: 'Email Opt In',
    detail: (
      <p>
        An <b>On Site</b> message allowing the user to <b>opt-in</b> to receive email messaging.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.RTMOverlayChannel',
          rtmTrigger: [{ type: '.Immediately' }],
          templateId: '',
        },
      ],
      eventTriggers: [EventTriggers.EMAIL_CHANGED],
      name: '',
      rules: [{ type: '.NoActiveMarketingPermission' }],
      subFeature: 'EMAIL_OPT_IN',
    },
  },
  ConfirmedOptIn: {
    icon: 'modal-window',
    name: 'Confirmed Email Opt In',
    detail: (
      <p>
        An <b>On Site</b> message allowing the user to <b>opt-in</b> to receive email messaging, including confirmation.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.RTMOverlayChannel',
          rtmTrigger: [{ type: '.Immediately' }],
          templateId: '',
        },
      ],
      eventTriggers: [EventTriggers.EMAIL_CHANGED],
      name: '',
      rules: [{ type: '.NoActiveMarketingPermission' }],
      subFeature: 'EMAIL_CONFIRMED_OPT_IN',
    },
  },
  OptOut: {
    icon: 'modal-window',
    name: 'Email Opt Out',
    detail: (
      <p>
        An <b>On Site</b> message allowing the user to <b>opt-out</b> from receiving email messaging.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.RTMOverlayChannel',
          rtmTrigger: [{ type: '.Immediately' }],
          templateId: '',
        },
      ],
      eventTriggers: [EventTriggers.EMAIL_CHANGED],
      name: '',
      rules: [{ type: '.NoActiveMarketingPermission' }],
      subFeature: 'EMAIL_OPT_OUT',
    },
  },
  SmsOptIn: {
    icon: 'modal-window',
    name: 'SMS Opt In',
    detail: (
      <p>
        An <b>On Site</b> message allowing the user to <b>opt-in</b> to receive SMS messaging.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.RTMOverlayChannel',
          rtmTrigger: [{ type: '.Immediately' }],
          templateId: '',
        },
      ],
      eventTriggers: [EventTriggers.PHONE_CHANGED],
      name: '',
      rules: [{ type: '.NoActiveSMSMarketingPermission' }],
      subFeature: 'SMS_OPT_IN',
    },
  },
  SmsOptOut: {
    icon: 'modal-window',
    name: 'SMS Opt Out',
    detail: (
      <p>
        An <b>On Site</b> message allowing the user to <b>opt-out</b> to receive SMS messaging.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.RTMOverlayChannel',
          rtmTrigger: [{ type: '.Immediately' }],
          templateId: '',
        },
      ],
      eventTriggers: [EventTriggers.PHONE_CHANGED],
      name: '',
      rules: [{ type: '.NoActiveSMSMarketingPermission' }],
      subFeature: 'SMS_OPT_OUT',
    },
  },
};
